const material = {
  getlist: 'material/getlist',
  add: 'material/add',
  update: 'material/update',
  remove: 'material/remove',
  get: 'material/get',
  getall: 'material/getall',
}
export default material
